import { takeEvery } from 'redux-saga/effects'
import { sagaActions } from './typeSagas'
import { toggleNotify } from './notification'
import {
  setCustomerAccessToken,
  setCustomerIdToken,
  clearCustomerTokens,
} from './auth'
import { updateFacilityList } from './booking/FacilityList'
import { updateFacilityOrder } from './booking/FacilityOrder'
import {
  updateOrderStartDates,
  updateOrderEndDates,
  updateOrderProductVariants,
  resetOrderProductVariants,
  updateOrderNumberOfPeople,
  updateOrderContactOfRepresentative,
  updateOrderPurpose,
  updateOrderSaleOfGoods,
  updateOrderEntryFee,
  updateOrderCalendar,
  updateOrderRate,
  resetOrderCreateInput,
} from './booking/OrderCreateInput'
import { updateCustomer } from './customer'
import { updateCustomerInput } from './customer/UpdateCustomer'
import {
  updateOrderCreateSuccess,
  removeOrderCreateSuccess,
} from './booking/OrderCreateSuccess'
import {
  updatePriceCalculate,
  removePriceCalculate,
} from './booking/PriceCalculate'
import { setSagaStoreID } from './sagaStore'
import {
  updateOrdersFilter,
  updateValueOrderFilter,
} from './mypage/ordersFilter'

export default function* rootSaga(): Generator {
  // For Authorization / Authentication
  yield takeEvery(sagaActions.UPDATE_ACCESS_TOKEN, setCustomerAccessToken)
  yield takeEvery(sagaActions.UPDATE_ID_TOKEN, setCustomerIdToken)
  yield takeEvery(sagaActions.CLEAR_TOKENS, clearCustomerTokens)

  yield takeEvery(sagaActions.TOGGLE_NOTIFY, toggleNotify)
  yield takeEvery(sagaActions.UPDATE_FACILITY_LIST, updateFacilityList)
  yield takeEvery(sagaActions.UPDATE_FACILITY_ORDER, updateFacilityOrder)
  // START CREATE ORDER BOOKING AREA
  yield takeEvery(sagaActions.UPDATE_ORDER_START_DATES, updateOrderStartDates)
  yield takeEvery(sagaActions.UPDATE_ORDER_END_DATES, updateOrderEndDates)
  yield takeEvery(
    sagaActions.UPDATE_ORDER_PRODUCT_VARIANTS,
    updateOrderProductVariants
  )
  yield takeEvery(
    sagaActions.RESET_ORDER_PRODUCT_VARIANTS,
    resetOrderProductVariants
  )
  yield takeEvery(
    sagaActions.UPDATE_ORDER_NUMBER_OF_PEOPLE,
    updateOrderNumberOfPeople
  )
  yield takeEvery(
    sagaActions.UPDATE_ORDER_CONTACT_OF_REPRESENTATIVE,
    updateOrderContactOfRepresentative
  )
  yield takeEvery(sagaActions.UPDATE_ORDER_PURPOSE, updateOrderPurpose)
  yield takeEvery(
    sagaActions.UPDATE_ORDER_SALE_OF_GOODS,
    updateOrderSaleOfGoods
  )
  yield takeEvery(sagaActions.UPDATE_ORDER_ENTRY_FEE, updateOrderEntryFee)
  yield takeEvery(sagaActions.UPDATE_ORDER_CALENDAR, updateOrderCalendar)
  yield takeEvery(sagaActions.UPDATE_ORDER_RATE, updateOrderRate)
  yield takeEvery(sagaActions.RESET_ORDER_INPUT, resetOrderCreateInput)
  // END CREATE ORDER BOOKING AREA
  yield takeEvery(sagaActions.UPDATE_ORDER_SUCCESS, updateOrderCreateSuccess)
  yield takeEvery(sagaActions.UPDATE_CUSTOMER, updateCustomer)
  yield takeEvery(sagaActions.UPDATE_CUSTOMER_INPUT, updateCustomerInput)
  yield takeEvery(sagaActions.REMOVE_ORDER_SUCCESS, removeOrderCreateSuccess)
  yield takeEvery(sagaActions.UPDATE_PRICE_CALCULATOR, updatePriceCalculate)
  yield takeEvery(sagaActions.RESET_PRICE_CALCULATOR, removePriceCalculate)
  yield takeEvery(sagaActions.UPDATE_SAGA_STORE_ID, setSagaStoreID)
  yield takeEvery(sagaActions.UPDATE_ORDERS_FILTER, updateOrdersFilter)
  yield takeEvery(
    sagaActions.UPDATE_VALUE_ORDERS_FILTER,
    updateValueOrderFilter
  )
}
